'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxImageCard } from '@/components/02-molecules/ImageCard/ImageCard'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxImagecardgrid } from './Imagecardgrid'
import { ImagecardgridProps } from './Imagecardgrid'

interface ImagecardgridBlokProps {
  blok: {
    title: ImagecardgridProps['title']
    description: ImagecardgridProps['description']
    items: SbBlokData[]
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
    alignment?: SbBlokData[]
  } & SbBlokData
}

const Imagecardgrid: FC<ImagecardgridBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxImagecardgrid
        title={blok.title}
        description={blok.description}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
        items={
          blok.items &&
          blok.items.map((blok: any) => (
            <PhnxImageCard
              key={blok._uid}
              title={blok.title ? (blok.title as string) : ''}
              paragraph={blok.paragraph ? (blok.paragraph as string) : ''}
              image={{
                src: blok.image ? (blok.image?.filename as string) : '',
                alt: blok.alt ? (blok.image.alt as string) : '',
              }}
              width={250}
            />
          ))
        }
      />
    </div>
  )
}

export default Imagecardgrid
